<template>
  <div class="l-dialog-box" v-if="visible">
    <div class="l-dialog">
      <!-- 主标题-大多数弹出层没有 -->
      <div class="l-dialog-title">
        <slot name="title"></slot>
      </div>
      <!-- 自定义提示信息 -->
      <div
        class="l-dialog-msg"
        :class="{ 'l-dialog-msg-special': dialogType == 2,'l-dialog-msg-hidden':dialogType == 3}"
      >
        <slot name="msg"></slot>
      </div>
      <!-- 按钮部分 -->
      <div class="l-dialog-btn-box">
        <button class="l-dialog-btn-out" @click="onCancle" v-if="hasCancleBtn">
          {{ cancleBtnText }}
        </button>
        <button class="l-dialog-btn-confirm" @click="onConfirm">
          {{ confirmBtnText }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "l-dialog",
  data() {
    return {
      visible: false,
    };
  },
  props: {
    //有“取消类”按钮
    hasCancleBtn: {
      type: [String, Boolean],
    },
    //取消按钮上的文字
    cancleBtnText: {
      default: "取消",
    },
    //确认按钮上的文字
    confirmBtnText: {
      default: "确定",
    },
    // 弹框显示
    modelShow: {
      type: Boolean,
      default: true,
    },
    autoClose: {
      type: Boolean,
      default: false,
    },
    dialogType: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    modelShow(val) {
      this.visible = val;
      //自动关闭弹框
      if (this.modelShow && this.autoClose) {
        setTimeout(() => {
          this.onConfirm();
        }, 3000);
      }
    },
  },
  methods: {
    //取消事件--有特殊事件处理
    onCancle(val) {
      this.$emit("cancle", val);
    },
    //确认事件--有特殊事件处理
    onConfirm(val) {
      this.$emit("confirm", val);
    },
  },
};
</script>
<style lang="stylus" scoped>
.l-dialog-box
  position fixed
  background rgba(0, 0, 0, 0.75)
  top 0
  left 0
  bottom 0
  right 0
  z-index 2001
  animation dialogAnimation 0.2s
  .l-dialog
    width 576px
    height 448px
    padding 10px
    box-sizing border-box
    margin 10% auto 0
    position relative
    display flex
    align-items center
    justify-content center
    flex-flow column
    background url('./images/l-bg-dialog.png?x-oss-process=image/interlace,1') no-repeat center
    background-size 100% 100% !important
    animation dialogBoxAnimation 0.5s
  .l-dialog-msg
    font-size 20px
    color #fff
    padding 25px
    display flex
    flex-direction column
    align-items center
    justify-content center
    width 75%
    box-sizing border-box
    min-height 128px
    max-height 200px
    overflow-y auto
    background: #23539C;
    box-shadow: 0px 0px 10px 0px rgba(35, 83, 156, 0.47) inset;
    border-radius: 28px;
    word-break break-word
  .l-dialog-msg-special{
    background:none;
    box-shadow:none;
    }
    .l-dialog-msg-hidden{
      overflow:hidden;
    }
  .l-dialog-btn-box
    margin-top 36px
  .l-dialog-btn-box > button, .l-confirm-btn
    border none
    border-radius 23px
    color #EA741B
    font-size 16px
    cursor pointer
    width 160px
    height 55px
    background-size 100%
  .l-dialog-btn-out
    margin-right 40px
    background url('./images/l-bg-gray.png') no-repeat
    color #828282
  .l-dialog-btn-confirm
    background url('./images/l-bg-yellow.png') no-repeat
  .l-dialog-title header
    font-size 24px
    font-weight bold
    color #fa9300
    -webkit-text-stroke 1px rgba(255, 255, 255, 0.8)
  @media (max-width 1600px)
    .l-dialog-record
      top 40px
      right 100px
      font-size 14px
    .l-dialog
      background url('./images/l-bg-dialog.png?x-oss-process=image/interlace,1') no-repeat
      width 504px
      height 347px
    .l-dialog-btn-box
      margin-top 20px
    .l-dialog-msg
      margin 10px auto 0
      padding 20px
      font-size 18px
    .l-dialog-btn-box > button, .l-confirm-btn
      width 145px
  @keyframes dialogAnimation
    0%
      opacity 0
    100%
      opacity 1
  @keyframes dialogBoxAnimation
    0%
      max-width 10%
      max-height 10%
    100%
      max-width 100%
      max-height 100%
</style>
